import { DAIMI_LG_INTRO, DAIMI_LG_SLUG } from '@/content/daimiLogistics'
import { focus } from '@/content/reportBuilder'
import type { Report } from '@/content/reportBuilder'

export const report: Report = {
  // The twenty-ninth report with a designed page of its own, and the fourteenth
  // focus cut to arrive with both of its figures — asked for on 2026-08-28 in the
  // same words as the Manufacturing and Pharmaceuticals cuts before it (*"referans
  // alarak ilgili sayfayı birebir tıpa tıp aynısını tasarla"*) with a four-part
  // full-page capture of the live page, the cover as two overlapping 2000px crops,
  // Figure 1 and the report mockup. See `content/daimiLogistics.ts` and
  // `pages/DaimiLogistics.tsx`. Not to be confused with the Future 2030 Logistics
  // outlook further down, which is a separate report on `'logistics-outlook'`.
  ...focus(
    DAIMI_LG_SLUG,
    'Logistics',
    'daimi-report-2026-logistics-cover',
    'fafd2dd3-53aa-41c3-b6d2-b83946568043-digitopia-daimi-2026-report-logistics.pdf',
  ),
  // The sector's own paragraphs, transcribed from the reference capture and held on
  // the page that says them — so the search result and the page cannot drift apart.
  // `prerender.tsx` takes the meta description from `body[0]`.
  body: DAIMI_LG_INTRO.body,
  layout: 'logistics-focus',
  // Its own words, its cover, its file and both of its figures, so `stillToCome`
  // has nothing left to say about it. What is still open is section-by-section on
  // its page, and `daimiLogisticsChecks()` carries that into the manifest.
  check: undefined,
}

/** Its place in the index grid — the order the imported page listed them. */
export const order = 11
